<ng-container *ngIf="vm$ | async as vm">
  <jb-static-booker-pod
    *ngIf="isStatic"
    textDark="true"
    [content]="vm.content"
    [ngClass]="{ paisley: vm.content.title === 'paisly' }"
  ></jb-static-booker-pod>
  <div
    *ngIf="!isStatic"
    [dot-debug-content]="vm.content"
    class="flex flex-column"
  >
    <jb-static-booker-pod
      *ngIf="isOdServiceDown$ | async"
      textDark="true"
      [content]="vm.content.serviceOutage.bodyText"
    ></jb-static-booker-pod>
    <!-- booker form -->
    <dot-booker-air-form
      *ngIf="!(isOdServiceDown$ | async)"
      [bookerId]="bookerId"
      [content]="vm.content"
      [form]="form"
      [airportHashMap]="airportMap$ | async"
      [tripType]="evaluatedTripType$ | async"
      [isTrueBlue]="evaluatedIsTrueBlue$ | async"
      [isInterlineRoute]="isInterlineRoute$ | async"
      [isInternationalRoute]="isInternationalRoute$ | async"
      [isMobile]="isMobile$ | async"
      [regions]="regions$ | async"
      [origins]="allFilteredAirports$ | async"
      [destinations]="destinations$ | async"
      [recentAirports]="recentAirports$ | async"
      [showValidationErrors]="showValidationErrors"
      [showCaptcha]="showCaptcha"
      [recentTravellerCount]="recentTravellerCount$ | async"
      [travelerCountError]="travelerCountError$ | async"
      [departDate]="recentDepartureDate$ | async"
      [departureDateError]="departureDateError$ | async"
      [returnDate]="recentReturnDate$ | async"
      [returnDateError]="returnDateError$ | async"
      [promoCodeWithSource]="promoCodeWithSource$ | async"
      [origin]="origin$ | async"
      [originError]="originAirportError$ | async"
      [destination]="destination$ | async"
      [destinationError]="destinationAirportError$ | async"
      (onOriginChange)="handleCityPairChange($event, 'origin')"
      (onDestinationChange)="handleCityPairChange($event, 'destination')"
      [showFormErrors]="showFormErrors$ | async"
    >
      <!-- submit button when button is inside the booker -->
      <div
        *ngIf="
          (form | jbGetFormControl: 'tripType').value !== tripTypeEnum.MULTICITY
        "
        non-multi-city
      >
        <button
          *ngrxLet="this.isMobile$; let isMobile"
          (click)="onSubmit(isMobile)"
          class="jb-booker-air-submit mt3-m"
          [class.mt3]="windowService.isMobile | async"
          jbButton
          [theme]="buttonThemeVar"
          [isPaired]="windowService.isDesktop | async"
          [isRounded]="true"
          type="button"
          data-qaid="searchFlight"
        >
          <span *ngIf="!submittingSearch" class="no-wrap">{{
            vm.content?.bookMessages?.submitButtonAir
          }}</span>
          <jb-icon
            *ngIf="submittingSearch"
            name="loading"
            class="fill-white mw3 w-100 dib h1"
          ></jb-icon>
        </button>
      </div>

      <!-- submit button multi-city when button is inside the booker -->
      <div
        *ngIf="
          (form | jbGetFormControl: 'tripType').value === tripTypeEnum.MULTICITY
        "
        class="db tc pt3 center w-100-s-override"
        multi-city
      >
        <ng-container
          *ngIf="bookerMultiCityStore.flights$ | async as multiCityFlights"
        >
          <button
            *ngrxLet="isMobile$; let isMobile"
            (click)="onMultiCitySubmit(multiCityFlights, form, isMobile)"
            class="dib multicity-booker-submit"
            jbButton
            [theme]="buttonThemeVar"
            [isRounded]="true"
            [isPaired]="false"
            type="button"
            data-qaid="searchFlight"
          >
            <ng-container>
              <span *ngIf="!submittingSearch">{{
                vm.content?.bookMessages?.submitButtonAir
              }}</span>
            </ng-container>
            <jb-icon
              *ngIf="submittingSearch"
              name="loading"
              class="fill-white mw3 w-100 dib h1"
            ></jb-icon>
          </button>
        </ng-container>
      </div>
    </dot-booker-air-form>
  </div>
</ng-container>
